module.exports = __webpack_public_path__ + "69efcfb701c795b8d7c64663feabecbe.svg";